module.exports = __webpack_public_path__ + "static/img/img-background-3.b4ee259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-3.png
// module id = ZFi3
// module chunks = 36